import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faBook,
  faCalendarPlus,
  faChartBar,
  faChessBoard,
  faEyeSlash,
  faExternalLinkAlt,
  faFeatherAlt,
  faGamepad,
  faPersonBooth,
  faTheaterMasks,
  faUser,
  faUsers,
  faHandHoldingHeart,
  IconDefinition,
  faGraduationCap,
  faGlobe,
  faList,
} from '@fortawesome/free-solid-svg-icons';
import React, { useContext } from 'react';
import Button from 'react-bootstrap/Button';
import { useHistory } from 'react-router-dom';
import Card from '../../shared/Card';
import { Beta } from '../../shared/icons';
import AppContext from '../../AppContext';
import { LogInButton } from '../../App/LogInButton';
import Sitemap from '../Sitemap';

const ButtonLink = (props: {
  children: React.ReactNode;
  to: string;
  [prop: string]: any;
}) => {
  const history = useHistory();
  const { children, to } = props;
  return (
    <Button onClick={() => history.push(to)} {...props}>
      {children}
    </Button>
  );
};

const ResponsiveFlex = (props: {
  children: React.ReactNode;
  [prop: string]: any;
}) => (
  <div
    style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'center' }}
    {...props}
  >
    {props.children}
  </div>
);

const FlexItem = (props: {
  children: React.ReactNode;
  [prop: string]: any;
}) => (
  <div
    style={{
      width: '300px',
      flex: '0 0 auto',
      margin: '1rem',
    }}
    {...props}
  >
    {props.children}
  </div>
);

const IconBullet = (props: {
  children: React.ReactNode;
  icon: IconDefinition;
  [prop: string]: any;
}) => (
  <li>
    <FontAwesomeIcon className="fa-fw me-2" {...props} />
    {props.children}
  </li>
);

function IndexStyledButtonLink({
  linkTo,
  color = '',
  renderButtonFAIcon,
  buttonLabel,
  children,
}: React.PropsWithChildren<{
  linkTo: string;
  color?: string;
  renderButtonFAIcon: IconDefinition;
  buttonLabel: string;
}>) {
  return (
    <>
      <ButtonLink
        to={linkTo}
        style={{
          width: '100%',
          backgroundColor: color,
          borderColor: color,
        }}
      >
        <div
          style={{
            fontSize: '200%',
          }}
        >
          <FontAwesomeIcon className="fa-fw me-2" icon={renderButtonFAIcon} />
          <br />
          {buttonLabel}
        </div>
      </ButtonLink>
      <div className="mt-2 text-muted">{children}</div>
    </>
  );
}

function IndexStyledButtonLinkPublic() {
  return (
    <IndexStyledButtonLink
      linkTo="/public"
      color="hotpink"
      renderButtonFAIcon={faHandHoldingHeart}
      buttonLabel="Healthy Relating"
    >
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <IconBullet icon={faUsers}>Public Forum</IconBullet>
        <IconBullet icon={faGraduationCap}>Modality Training</IconBullet>
        <IconBullet icon={faPersonBooth}>Topic rooms</IconBullet>
        <IconBullet icon={faChartBar}>
          Community statistics and leaderboards
        </IconBullet>
        <IconBullet icon={faCalendarPlus}>Events</IconBullet>
        {/* <IconBullet icon={faSnowplow}>
Slow to load but functional
</IconBullet> */}
      </ul>
    </IndexStyledButtonLink>
  );
}

function IndexStyledButtonLinkPrivate() {
  return (
    <IndexStyledButtonLink
      linkTo="/private"
      color="rebeccapurple"
      renderButtonFAIcon={faBook}
      buttonLabel="Private Writing"
    >
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <IconBullet icon={faEyeSlash}>Private journaling</IconBullet>
        <IconBullet icon={faChartBar}>
          Word count and frequency analysis
        </IconBullet>
        <IconBullet icon={faTheaterMasks}>Sentiment analysis</IconBullet>
        <IconBullet icon={faFeatherAlt}>
          Full screen zen writing mode
        </IconBullet>
      </ul>
    </IndexStyledButtonLink>
  );
}

function IndexStyledButtonLinkGames() {
  return (
    <IndexStyledButtonLink
      linkTo="/games"
      renderButtonFAIcon={faGamepad}
      buttonLabel="Games"
    >
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <IconBullet icon={faPersonBooth}>
          Multiplayer Lobby and Game Rooms
        </IconBullet>
        <IconBullet icon={faGlobe}>
          Shared Single Instance Multiplayer
        </IconBullet>
        <IconBullet icon={faUser}>Solitaire Solo-Play</IconBullet>
      </ul>
    </IndexStyledButtonLink>
  );
}

function IndexStyledButtonLinkLists() {
  return (
    <IndexStyledButtonLink
      linkTo="/lists"
      color="rebeccapurple"
      renderButtonFAIcon={faList}
      buttonLabel={`Lists`}
    >
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <IconBullet icon={faUser}>Self Discovery</IconBullet>
        <IconBullet icon={faList}>Priotiries Clarified</IconBullet>
      </ul>
    </IndexStyledButtonLink>
  );
}

function IndexStyledExternalLinkClueSweeper() {
  return (
    <>
      <style>
        {`.cluesweeper-btn::after { content: none !important; }`}
      </style>
      <a
        href="https://cluesweeper.com"
        target="_blank"
        rel="noopener noreferrer"
        className="btn btn-primary cluesweeper-btn"
        style={{
          width: '100%',
          backgroundColor: '#2c5282',
          borderColor: '#2c5282',
        }}
      >
        <div
          style={{
            fontSize: '200%',
          }}
        >
          <FontAwesomeIcon className="fa-fw me-2" icon={faChessBoard} />
          <br />
          Clue Sweeper
        </div>
      </a>
      <div className="mt-2 text-muted">
        <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
          <IconBullet icon={faUsers}>Team Game</IconBullet>
          <IconBullet icon={faChessBoard}>Codenames-style</IconBullet>
          <IconBullet icon={faGlobe}>
            <a href="https://cluesweeper.com" target="_blank" rel="noopener noreferrer">
              cluesweeper.com
            </a>
          </IconBullet>
        </ul>
      </div>
    </>
  );
}

function IndexStyledButtonLinkChat() {
  return (
    <IndexStyledButtonLink
      linkTo="/chat"
      color="hotpink"
      renderButtonFAIcon={faUsers}
      buttonLabel="Chat"
    >
      <ul style={{ listStyle: 'none', paddingLeft: 0 }}>
        <IconBullet icon={faUsers}>Public Chat Room</IconBullet>
        <IconBullet icon={faHandHoldingHeart}>Healthy Relating</IconBullet>
        <IconBullet icon={faGlobe}>Community Connection</IconBullet>
      </ul>
    </IndexStyledButtonLink>
  );
}

const IndexPageMainMenuItemMedium = {
  Chat: IndexStyledButtonLinkChat,
  ClueSweeper: IndexStyledExternalLinkClueSweeper,
  Public: IndexStyledButtonLinkPublic,
  Private: IndexStyledButtonLinkPrivate,
  Games: IndexStyledButtonLinkGames,
  Lists: IndexStyledButtonLinkLists,
};

// TODO: allow user to set their own preferred home page!  this dashboard | public | private | games
const Index = () => {
  const { user } = useContext(AppContext);

  return (
    <>
      <Card>
        {!user && (
          <>
            <div className="d-flex align-items-center gap-2">
              <LogInButton
                variant="secondary-outline"
                style={{ padding: '0.25rem 0.5rem' }}
              >
                Login Required:
              </LogInButton>
            </div>
          </>
        )}
        <ResponsiveFlex>
          <FlexItem>
            <IndexPageMainMenuItemMedium.Private />
          </FlexItem>
          <FlexItem>
            <IndexPageMainMenuItemMedium.Lists />
          </FlexItem>
          <FlexItem>
            <IndexPageMainMenuItemMedium.Games />
          </FlexItem>
          <FlexItem>
            <IndexPageMainMenuItemMedium.Public />
          </FlexItem>
          <FlexItem>
            <IndexPageMainMenuItemMedium.ClueSweeper />
          </FlexItem>
        </ResponsiveFlex>
      </Card>
      <Card className="mt-4">
        <Sitemap />
      </Card>
    </>
  );
};

export default Index;
